import { call, put, takeLatest } from "redux-saga/effects";
import { tienThuaHocSinhApi } from "../../../api/category/tienThuaHocSinhApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eTienThuaHocSinhActionTypeIds, ITienThuaHocSinhActions } from "../../action-types/category/ITienThuaHocSinhActionType";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.category.tienThuaHocSinh;

export function* tienThuaHocSinhSaga(): any {
    yield takeLatest(eTienThuaHocSinhActionTypeIds.LOAD_START, loadWorker);
    yield takeLatest(eTienThuaHocSinhActionTypeIds.LOAD_HOCSINH_START, loadHocSinhWorker);
}

function* loadWorker(action: ITienThuaHocSinhActions): any {
    const payload = action.payload as { dm_coso_id?: number } | undefined;
    const cosoId = parseInt(localStorage.getItem("dm_coso_id") ?? "0") || 0;
    const requestParams: { dm_coso_id: number } = {
        dm_coso_id: payload?.dm_coso_id || cosoId,
    };

    const res: IBaseRespone = yield call(tienThuaHocSinhApi.SelectAll, requestParams)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"))
    }
}

function* loadHocSinhWorker(action: ITienThuaHocSinhActions): any {
    const id = action.payload as number;
    const res: IBaseRespone = yield call(tienThuaHocSinhApi.SelectByHocSinh, id)
    if (res.is_success) {
        yield put(mainAction.LOAD_HOCSINH_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_HOCSINH_ERROR(res.message ?? "Có lỗi"))
    }
}
